import type { Dispatch } from '@reduxjs/toolkit';
import { captureException } from '@sentry/react';
import { isAxiosError } from 'axios';
import { addAppAlertDialog, addAppBackendErrorMessage, addAppErrorMessage } from 'modules/alerts/state';
import { isApiErrors, isApiResponse } from 'modules/api/utils';

// TODO refactor args to single object
export function handleQueryError(
  error: unknown,
  dispatch: Dispatch,
  metadata: string,
  message: string,
  showAlertDialog = false
) {
  captureException(error, {
    tags: {
      metadata,
      message,
    },
  });

  if (showAlertDialog) {
    dispatch(
      addAppAlertDialog({
        title: message,
        description: '',
        severity: 'danger',
      })
    );
  } else if (isApiResponse(error) && isAxiosError(error.data) && error.status === 500) {
    dispatch(addAppBackendErrorMessage('Unknown server error'));
  } else if (isApiResponse(error) && isApiErrors(error.data)) {
    error.data.errors.forEach(({ message: apiErrorMessage }) => {
      dispatch(addAppErrorMessage(apiErrorMessage));
    });
  } else {
    dispatch(addAppErrorMessage(message));
  }
}
